export default __webpack_public_path__ + "static/ti_caravan_block-32ed9e6968c08b653b9e60aa2faafe89.svg";